<template>
  <div>
    <div id="CreatCodeModal" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modal.title }}</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.code" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>کد هدیه</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" required v-model="modal.days" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>تعداد روز</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" required v-model="modal.coins" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>تعداد سکه</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <p>محدودیت تعداد استفاده</p>
                      <select class="form-control" name="" id="" v-model="modal.isMaxActive">
                        <option :value="true">فعال</option>
                        <option :value="false">غیر فعال</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="modal.isMaxActive" class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" required v-model="modal.maxUseCount" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>سقف استفاده</label>
                    </div>
                  </div>
                </div>

                <div v-if="modal._id" class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <p>
                        تعداد استفاده تا الان: <span class="text-warning">{{ modal.usedCount }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <p>بررسی اشتراک</p>
                      <select class="form-control" name="isActive" v-model="modal.deactiveForFirstUse">
                        <option value="true">فقط کاربرانی که حد اقل یک بار اشتراک خریده اند</option>
                        <option value="false">برای همه کاربران حتی کسانی که تابحال اشتراک نخریده اند</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <p>وضعیت تاریخ انقضا</p>
                      <select class="form-control" name="isActive" v-model="modal.expireAble">
                        <option value="true">دارد</option>
                        <option value="false">ندارد</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div v-if="modal.expireAble == 'true' || modal.expireAble == true" class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <!-- <div class="group material-input"> -->
                    <p>تاریخ انقضا</p>
                    <date-picker
                      name="startDate"
                      type="datetime"
                      inputFormat="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      locale="fa,en"
                      altFormat="MM-DD-YYYY HH:mm"
                      v-model="modal.expireDate"
                    ></date-picker>
                    <!-- </div> -->
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <p>وضعیت</p>
                      <select class="form-control" name="isActive" v-model="modal.isActive">
                        <option value="true">فعال</option>
                        <option value="false">غیر فعال</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-shadow" data-dismiss="modal">
                بستن
              </button>
              <button type="submit" class="btn btn-primary" @click="handleClick">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    modal: {
      username: '',
      phone: '',
      password: null,
    },
  },

  watch: {
    modal(newValue, oldValue) {
      console.log(newValue), console.log(oldValue);
    },
  },
  methods: {
    handleClick() {
      this.modal.access = 'admin';
      this.$emit('clicked', this.modal);
    },
    changeIsActive(event) {
      this.modal.sort = event.target.value;
    },
    removeFiles() {},
    async imageSelected(e) {
      console.log(e.target.id);
      this.image = e.target.files[0];
    },
  },
};
</script>
